export const KEY_STORAGE_FAVO = 'KEY/STORAGE/FAVO'

export const KEY_STORAGE_PUSHDEVICE = 'KEY/STORAGE/PUSHDEVICE'
export const KEY_STORAGE_PUSHMESSAGE = 'KEY/STORAGE/PUSHMESSAGE'


// WEBPACK FOOTER //
// ./src/appdef.js